/**
 * Crawler-friendly internal links for the homepage. Visually hidden so the
 * public UI stays unchanged; mirrors the noscript "Explore JigsawML" block.
 */
import React from "react";
import { Link } from "react-router-dom";
import { HOMEPAGE_GITHUB_APP_SEO_NAV_LABEL } from "../../../constants/platformCopy";
import { getPublicCanvasSeoNavItems } from "../../../constants/publicCanvasSeo";
import seoStyles from "../../../utils/seoVisuallyHidden.module.css";

const HomepageSeoNav: React.FC = () => {
  const publicCanvasLinks = getPublicCanvasSeoNavItems();

  return (
    <nav
      aria-label="Explore JigsawML"
      aria-hidden="true"
      className={seoStyles.visuallyHidden}
    >
      <h2>Explore JigsawML</h2>
      <ul>
        <li>
          <Link to="/product" tabIndex={-1}>
            Software Architecture Visualizer — Auto-generate interactive
            architecture diagrams from code
          </Link>
        </li>
        <li>
          <Link to="/pull-request-helper" tabIndex={-1}>
            {HOMEPAGE_GITHUB_APP_SEO_NAV_LABEL}
          </Link>
        </li>
        <li>
          <Link to="/open-source-projects" tabIndex={-1}>
            Open-Source Projects — Explore JigsawML generated architectures of
            popular open-source repositories
          </Link>
        </li>
        {publicCanvasLinks.map(({ slug, path, label }) => (
          <li key={slug}>
            <Link to={path} tabIndex={-1}>
              {label}
            </Link>
          </li>
        ))}
        <li>
          <Link to="/demo" tabIndex={-1}>
            Demo — See JigsawML in action
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default HomepageSeoNav;
